__turbopack_context__.v({
  "root": "Paragraph-module__lg0orW__root" + " " + __turbopack_context__.i(95264)["paragraphStyles"],
});
